import Products from '@/screens/providers/Products'
import ProviderDeposits from '@/screens/providers/Deposits'
import ProviderOrders from '@/screens/providers/Orders'
import ProviderUsers from '@/screens/providers/Users'
import ProviderInbox from '@/screens/providers/Inbox'
import ProviderToConfirm from '@/screens/providers/ToConfirm'
import ProviderToInvoice from '@/screens/providers/ToInvoice'
import ProviderToDeliver from '@/screens/providers/ToDeliver'
import ProviderTaxes from '@/screens/providers/Taxes'
import ProviderClients from '@/screens/providers/Clients'
import ProviderDuplicateProducts from '@/screens/providers/ListVariantsDuplicate'

import auth from './middleware/auth'

const routes = [
  {
    path: '/products',
    component: Products,
    name: 'Products',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/provider-deposits',
    component: ProviderDeposits,
    name: 'ProviderDeposits',
    meta: {
      requireAuth: true,
      permissions: ['provider'],
      middleware: { auth }
    }
  },
  {
    path: '/provider-taxes',
    component: ProviderTaxes,
    name: 'ProviderTaxes',
    meta: {
      requireAuth: true,
      permissions: ['provider'],
      middleware: { auth }
    }
  },
  {
    path: '/provider-orders',
    component: ProviderOrders,
    name: 'ProviderOrders',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/inbox',
    component: ProviderInbox,
    name: 'ProviderInbox',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/to-confirm',
    component: ProviderToConfirm,
    name: 'ProviderToConfirm',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/to-invoice',
    component: ProviderToInvoice,
    name: 'ProviderToInvoice',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/to-deliver',
    component: ProviderToDeliver,
    name: 'ProviderToDeliver',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/customer-credit',
    component: ProviderClients,
    name: 'ProviderClient',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/products/variants-duplicates',
    component: ProviderDuplicateProducts,
    name: 'DuplicateVariants',
    meta: {
      requireAuth: true,
      permissions: ['provider', 'provider-buyer', 'provider-manager'],
      middleware: { auth }
    }
  },
  {
    path: '/users-provider',
    component: ProviderUsers,
    name: 'ProviderUsers',
    meta: {
      requireAuth: true,
      permissions: ['provider'],
      middleware: { auth }
    }
  }
]

export default routes
